import { VoidComponent } from "solid-js";
import { TextButton } from "../../../../../../../components/button/Button";
import { useTranslation } from "../../../../../../../state/i18n";

const ContactUsAction: VoidComponent = () => {
  const { t } = useTranslation();

  return (
    <TextButton
      text={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_ACTION_CONTACT_US_LABEL)}
      variant="secondary"
      size="medium"
    />
  );
};

export default ContactUsAction;
